import classNames from 'classnames';

import {
  CTA_TYPE,
  Heading,
  HEADING_SIZE,
  HEADING_TAG,
  ListComponentV3,
  LIST_VARIANT,
  MainBanner,
  PageSection,
  SecondaryBanner,
  SECONDARY_BANNER_VARIANT,
  SECTION_THEME,
  useDeviceSize,
} from '@amzn/sss-website-theme';

import { ROUTES } from 'src/enums/Routes';
import { getImageRoot, t } from 'src/helpers';

// eslint-disable-next-line no-restricted-imports
import styles from '../Btf.module.scss';

enum SECTION_IDS {
  CARBON_STANDARD = 'carbon-standard',
  MEASUREMENT = 'measurement',
}

interface SingleSegmentCreditBtfTemplateProps {
  productDetailsBundle: any;
}

export const SingleSegmentCreditBtfTemplate = ({ productDetailsBundle }: SingleSegmentCreditBtfTemplateProps) => {
  const { isSmallDesktop } = useDeviceSize();
  const imageRoot = getImageRoot(isSmallDesktop);

  return (
    <>
      <PageSection>
        <Heading className={styles.learnMoreHeading} as={HEADING_TAG.H3} size={HEADING_SIZE.h3}>
          {t(productDetailsBundle, 'learnMore_heading')}
        </Heading>
        <ListComponentV3
          theme={SECTION_THEME.Light_Spruce}
          items={[
            {
              title: t(productDetailsBundle, 'learnMore_title'),
              subtitle: t(productDetailsBundle, 'learnMore_subtitle'),
              image: {
                src: `${imageRoot}/superpollutant-segment.jpg`,
                alt: t(productDetailsBundle, 'learnMore_blue_sky_alt'),
              },
              cta: {
                href: `${ROUTES.CREDITS_SEGMENT_SUPERPOLLUTANTS}`,
                type: CTA_TYPE.Link,
                forceServerSideNav: true,
              },
              label: t(productDetailsBundle, 'learnMore_exploreScience'),
              theme: SECTION_THEME.Light_Spruce,
              variant: LIST_VARIANT.Accordion,
              exploreCopy: t(productDetailsBundle, 'learnMore_explore'),
              newTabCopy: t(productDetailsBundle, 'learnMore_newTab'),
              pdfCopy: t(productDetailsBundle, 'learnMore_pdf'),
            },
          ]}
        />
      </PageSection>
      <PageSection className={classNames(styles.pageSection)} theme="medium-spruce" id={SECTION_IDS.CARBON_STANDARD}>
        <SecondaryBanner
          imagePrimary={{
            src: `${imageRoot}/refrigerant-carbonstandard-1.jpg`,
            alt: t(productDetailsBundle, 'carbonStandard_tanks_alt'),
          }}
          imageSecondary={{
            src: `${imageRoot}/refrigerant-carbonstandard-2.png`,
            alt: t(productDetailsBundle, 'carbonStandard_acr_alt'),
          }}
          title={t(productDetailsBundle, 'carbonStandard_title')}
          subTitle=""
          description={t(productDetailsBundle, 'carbonStandard_description')}
          theme={SECTION_THEME.Sustainability_Spruce}
          cta={{
            label: t(productDetailsBundle, 'carbonStandard_cta'),
            link: 'https://acrcarbon.org/wp-content/uploads/2023/09/ACR-ODS-International-v1.0-2021-04.pdf',
          }}
          variant={SECONDARY_BANNER_VARIANT.LEFT}
        />
      </PageSection>

      <PageSection id={SECTION_IDS.MEASUREMENT} theme="light-spruce">
        <MainBanner
          image={{
            src: `${imageRoot}/refrigerant-MRV.jpg`,
            alt: t(productDetailsBundle, 'measurement_refrigerantMRV_alt'),
          }}
          theme={SECTION_THEME.Sustainability_Spruce}
          title={t(productDetailsBundle, 'measurement_title')}
          subtitle={t(productDetailsBundle, 'measurement_subtitle')}
          accordions={[
            {
              title: t(productDetailsBundle, 'measurement_measurement'),
              content: [
                {
                  text: t(productDetailsBundle, 'measurement_measurement_content'),
                },
              ],
            },
            {
              title: t(productDetailsBundle, 'measurement_reporting'),
              content: [
                {
                  text: t(productDetailsBundle, 'measurement_reporting_content'),
                },
              ],
            },
            {
              title: t(productDetailsBundle, 'measurement_verification'),
              content: [
                {
                  text: t(productDetailsBundle, 'measurement_verification_content'),
                },
              ],
            },
          ]}
        />
      </PageSection>
    </>
  );
};
